"use client";

import type { SchedulingDuration } from "@repo/api";
import { SelectField } from "@repo/ui/form-fields";
import { useFieldBinding } from "@/shared/forms/connected-fields";
import { DURATION_OPTIONS } from "./duration-picker";

function encode(d: SchedulingDuration): string {
  if (!d.value) return "";
  return `${d.value}-${d.unit}`;
}

function decode(key: string): SchedulingDuration {
  const [val, unit] = key.split("-");
  return { value: Number(val), unit: unit as "min" | "h" };
}

export interface DurationFieldProps {
  label?: string;
  description?: string;
  disabled?: boolean;
}

export function DurationField({ label, description, disabled }: DurationFieldProps) {
  const { value, onChange, onBlur, errors, isTouched } = useFieldBinding<SchedulingDuration>();

  return (
    <SelectField
      value={encode(value)}
      onChange={(v) => {
        if (v) onChange(decode(v));
        onBlur();
      }}
      onBlur={onBlur}
      errors={errors}
      isTouched={isTouched}
      label={label}
      description={description}
      placeholder="Select duration"
      options={DURATION_OPTIONS.map((o) => ({ value: encode(o), label: o.label }))}
      disabled={disabled}
    />
  );
}
